import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  return <AnimatePresence data-id="element-44">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-[#5C4A3A]/60 backdrop-blur-sm z-50" data-id="element-45" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-46">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden pointer-events-auto" data-id="element-47">
              {/* Header */}
              <div className="sticky top-0 bg-white border-b border-[#E8A87C]/20 px-6 py-4 flex items-center justify-between" data-id="element-48">
                <h2 className="text-2xl font-serif font-bold text-[#5C4A3A]" data-id="element-49">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 hover:bg-[#FBF8F3] rounded-full transition-colors" aria-label="Cerrar" data-id="element-50">
                  <X className="h-5 w-5 text-[#5C4A3A]" data-id="element-51" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-52">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}